import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=54b4a51a&"
import script from "./Dashboard.vue?vue&type=script&lang=babel&"
export * from "./Dashboard.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports